export default __webpack_public_path__ + "static/media/unstoppable-icon.5ecf9845.png";